import type { RfqDto } from '../api/types'

export const rfqDisplayLabel = (rfq: Pick<RfqDto, 'displayNumber' | 'title'>): string =>
  rfq.displayNumber ?? rfq.title
